import React from 'react';
import _ from 'lodash';
import t from '~t';

import { Section, SectionTitle, SectionActions, Button, cn, Icon } from '~ui';

export default function FiltersSection({
  className = '',
  item: { hidden },
  hideSection,
  getLink,
  ...props
}) {
  return (
    <Section {...props} className={cn('cursor-pointer', className)}>
      <SectionTitle>{_.capitalize(t.s('fastFilter'))}</SectionTitle>

      {props.onContextMenu && (
        <SectionActions>
          {hidden ? (
            <Button variant='outline' size='sm'>
              {t.s('show')}
            </Button>
          ) : (
            <Button
              variant='ghost'
              size='icon'
              title={t.s('more')}
              onClick={props.onContextMenu}
            >
              <Icon name='more_horizontal' />
            </Button>
          )}
        </SectionActions>
      )}
    </Section>
  );
}
